import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import SalesCatalystInput from '../common/SalesCatalystInput';
import removeIcon from '../../images/clear-field-icon.png';
import { PREFERENCE_SALES_CATALYST, PREFERENCE_SALES_CATALYST_SUBENTITIES,
  PREFERENCE_SALES_CATALYST_SELECTED_SE_LIST, SALES_CATALYST } from '../../constants';
import { createWarningMessageObj } from '../../util/preferenceUtils';
import {
  SC_SAVE_MODIFIED_PACKAGE_LIST,
} from '../../messages/messages';

const scSubEntitiesKey = `${PREFERENCE_SALES_CATALYST}.${PREFERENCE_SALES_CATALYST_SUBENTITIES}`;

class PreferencesCommonDataInput extends Component {
  constructor(props) {
    super(props);
    const keys = props.field.dbKey.split('.');
    this.state = {
      inputData: props.modifiedPreferences !== undefined && !_.isEmpty(props.modifiedPreferences) &&
        props.modifiedPreferences[keys[0]][keys[1]] !== undefined ?
        props.modifiedPreferences[keys[0]][keys[1]] : [],
    };
  }

  componentDidMount() {
    const { field, sessionScreen, subEntities, selectedList } = this.props;
    if (sessionScreen && field.dbKey === scSubEntitiesKey && !_.isEmpty(subEntities)) {
      this.clearAllAndUpdate(subEntities, selectedList);
    }
  }

  /* eslint-disable camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { field, modifiedPreferences } = this.props;
    const keys = field.dbKey.split('.');
    if (modifiedPreferences !== nextProps.modifiedPreferences) {
      if (field.dbKey === scSubEntitiesKey) {
        const selListKey = PREFERENCE_SALES_CATALYST_SELECTED_SE_LIST;
        if (_.isEmpty(nextProps.modifiedPreferences[keys[0]][selListKey]) &&
        _.isEmpty(nextProps.modifiedPreferences[keys[0]][keys[1]])) {
          this.setWarningMessage(1);
        } else if (_.isEmpty(nextProps.modifiedPreferences[keys[0]][selListKey]) &&
          !_.isEmpty(nextProps.modifiedPreferences[keys[0]][keys[1]])) {
          this.setWarningMessage();
        } else if (modifiedPreferences[keys[0]] &&
          !_.isEqual(modifiedPreferences[keys[0]][selListKey],
          nextProps.modifiedPreferences[keys[0]][selListKey])) {
          this.setWarningMessage(1);
        }
      }
      this.setState({
        inputData: nextProps.modifiedPreferences !== undefined && !_.isEmpty(nextProps.modifiedPreferences) &&
        nextProps.modifiedPreferences[keys[0]][keys[1]] !== undefined ?
        nextProps.modifiedPreferences[keys[0]][keys[1]] : [],
      });
    }
  }

  setWarningMessage = type => {
    const { field } = this.props;
    if (field.dbKey === scSubEntitiesKey) {
      const warningData = createWarningMessageObj(
        'SalesCatalyst',
        scSubEntitiesKey,
        SALES_CATALYST,
        SC_SAVE_MODIFIED_PACKAGE_LIST,
        type
      );
      this.props.setPreferenceWarning(warningData);
    }
  }

  deleteHandler = (field, subCategory, index) => {
    const { inputData } = this.state;
    const clonedData = _.cloneDeep(inputData);
    const removeIndexItem = _.remove(clonedData, (n, i) => {
      return i !== index;
    });
    this.props.updatePreferences(
      subCategory,
      removeIndexItem,
    );
    this.setWarningMessage();
  }

  forceLabelUpdate = ({ data }) => {
    const { field } = this.props;
    const { inputData } = this.state;
    const updatedDataItem = _.cloneDeep(inputData);
    updatedDataItem[data.indexToUpdate] = {
      ...updatedDataItem[data.indexToUpdate],
      defId: data.defId,
      expId: data.expressionId,
      expression: data.labelExpression,
      label: data.label,
    };
    this.props.updatePreferences(
      field.dbKey,
      updatedDataItem
    );
    this.setWarningMessage();
  }

  clearAllAndUpdate = (data, selectedList) => {
    const { field } = this.props;
    const newSelectedList = {};
    if (!_.isEmpty(selectedList)) {
      newSelectedList.label = selectedList.templateName;
      newSelectedList.value = selectedList.templateId;
    }
    if (field.updateKey !== undefined) {
      if (field.dbKey === scSubEntitiesKey) {
        setTimeout(() => {
          this.props.updatePreferences(
            field.updateKey,
            !_.isEmpty(newSelectedList) ? newSelectedList : {},
          );
          this.props.updatePreferences(
            field.updateKeySl,
            !_.isEmpty(newSelectedList) ? newSelectedList.label : '',
          );
        }, 0);
      }
    }
    this.props.updatePreferences(
      field.dbKey,
      !_.isEmpty(data) ? data : [],
    );
    this.setWarningMessage(!_.isEmpty(data) ? undefined : 1);
  }

  render() {
    const { field } = this.props;
    const { inputData } = this.state;
    return (
      <div className="preferences-cmn-data-container">
        {field.textElements !== undefined && (
          <div className="row expanded">
            {field.textElements.helperText && 
              <div className="column medium-7 pcd-helper-txt">{field.textElements.helperText}</div>
            }
            {field.textElements.clearAllText && <div className="column medium-5 float-right text-right pcd-clearall">
              <button
                disabled={inputData.length === 0}
                type="button"
                onClick={() => this.clearAllAndUpdate()}
              >
                {field.textElements.clearAllText}
              </button>
            </div>}
          </div>
        )}
        <div className="preferences-cmn-data-input">
          {_.map(inputData, (o, i) => (
            <div key={`${field.field}-${i}`}>
              <SalesCatalystInput
                data={o}
                deleteHandler={this.deleteHandler}
                subCategory={field.dbKey}
                field={undefined}
                index={i}
                targetLabelClass="preferences-cmn-data-input-list"
                dataList={inputData}
                removeIcon={removeIcon}
                disableSWInfo
                editBlockTopMargin="0"
                editModeClass="preferences-cmn-data-input-edit"
                forceLabelUpdate={this.forceLabelUpdate}
              />
            </div>
          ))}
          {inputData !== undefined && inputData.length === 0 &&
            <div className="empty-input-item">&nbsp;</div>
          }
        </div>
      </div>
    );
  }
}

PreferencesCommonDataInput.propTypes = {
  field: PropTypes.shape({
    menuName: PropTypes.string,
    style: PropTypes.shape({}),
    defaultValue: PropTypes.arrayOf(PropTypes.shape({})),
    textElements: PropTypes.arrayOf(PropTypes.shape({})),
    dbKey: PropTypes.string,
    updateKey: PropTypes.string,
    updateKeySl: PropTypes.string,
    field: PropTypes.string,
  }),
  modifiedPreferences: PropTypes.shape({}),
  setPreferenceWarning: PropTypes.func,
  sessionScreen: PropTypes.bool,
  selectedList: PropTypes.shape({}),
  updatePreferences: PropTypes.func,
  subEntities: PropTypes.arrayOf(PropTypes.shape({})),
};


function mapStateToProps(state) {
  return {
    subEntities: state.salesCatalyst.dataSelection.subEntities,
    selectedList: state.salesCatalyst.scConfiguration.package.selectedList,
  };
}

export default connect(
  mapStateToProps,
  null,
  )(PreferencesCommonDataInput);
